import { AxiosResponse } from 'axios'
import axiosInstance from './http-common'

export interface Directory {
  name: string
  totalSisze: number
  lastModified: string
}
export interface DirectoryResponse {
  contents: Directory[]
}

export type Type = 'directories' | 'files'

class FilesAndDirectoriesService {
  //directory
  addDirectory = async (organization: string, project: string, name: string, directoryPath?: string): Promise<any> => {
    return (
      await axiosInstance.post(`/${organization}/directories`, {
        name: name,
        path: `${project}${directoryPath ? `/${directoryPath}` : ''}`,
      })
    ).data
  }

  async getDirectoryContents(org: string, path: string): Promise<DirectoryResponse> {
    return (await axiosInstance.get(`/${org}/directories/${encodeURIComponent(path)}`))?.data
  }

  //files
  async uploadFile(org: string, path: string, file: File) {
    const formData = new FormData()

    formData.append('fileStream', file)

    return (
      await axiosInstance.post(`/${org}/files/upload/${encodeURIComponent(path)}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
    ).data
  }

  async saveFile(org: string, path: string, file: File) {
    const formData = new FormData()

    formData.append('fileStream', file)

    return (
      await axiosInstance.post(`/${org}/files/save/${encodeURIComponent(path)}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
    ).data
  }

  async replaceFile(org: string, path: string, file: File) {
    const formData = new FormData()

    formData.append('fileStream', file)

    return (
      await axiosInstance.post(`/${org}/files/replace/${encodeURIComponent(path)}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
    ).data
  }

  //common
  async download(org: string, path: string, type: Type): Promise<any> {
    return await axiosInstance.get(`/${org}/${type}/download/${encodeURIComponent(path)}`, {
      responseType: 'blob',
    })
  }

  duplicate = async (organization: string, path: string, type: Type): Promise<AxiosResponse<Blob>> => {
    return (await axiosInstance.post(`/${organization}/${type}/duplicate/${encodeURIComponent(path)}`)).data
  }

  rename = async (organization: string, path: string, newName: string, type: Type): Promise<any> => {
    return (
      await axiosInstance.put(`/${organization}/${type}/rename/${encodeURIComponent(path)}`, { newName: newName })
    ).data
  }

  move = async (organization: string, path: string, newPath: string, type: Type): Promise<any> => {
    return (
      await axiosInstance.put(`/${organization}/${type}/move/${encodeURIComponent(path)}`, {
        newPath: newPath,
      })
    ).data
  }

  delete = async (organization: string, path: string, type: Type): Promise<any> => {
    return (await axiosInstance.delete(`/${organization}/${type}/${encodeURIComponent(path)}`)).data
  }
}

export default new FilesAndDirectoriesService()
